import utils from "Sources/utils/utils";
//import NavUtils from "Sources/utils/navigation-utils";
const log = require("Sources/utils/logger")();
import LanguageManager from "Sources/services/language-manager";
import HtmlTemplate from "Views/partials/objectives/mission-objective-category.html";
import ObjectiveTemplate from "Views/partials/objectives/mission-objective.html";

import "Styles/components/mission-material.scss";
import {isVisible} from "../../libs/bootstrap/js/src/util";
import MissionObjective from "./mission-objective";

class MissionObjectiveCategory
{
  constructor(options)
  {
    this.$container = $(options.container);
    this.hasRendered = false;
    this.category = options.category;
    this.objectives = options.objectives;
    this.showCheckmarks = options.showCheckmarks;
    this.categoryOpen = false;
    this.objectiveObjects = [];
  }

  get category()
  {
    return this._category;
  }

  set category(category)
  {
    this._category = category;
    this.updateCategory();
  }

  static setUpMissionObjectiveCategory(options)
  {
    let instance = new MissionObjectiveCategory(options);
    instance.render();
    instance.setUpObjectives();
    instance.setUpEventListeners();
    instance.categoryOpenToggle();
    return instance;
  }


  setUpObjectives()
  {
    this.objectiveObjects = [];

    let that = this;

    //set up objective elements
    this.objectives.forEach(function(objective){
      let container = "#objectives-" + that.category.key;

      let objectiveObject = MissionObjective.setUpMissionObjective({ container: container,
        objective: {
          key : objective.key,
          name : objective.name,
          category: objective.category,
          code: objective.code
        },
        selected: objective.selected,
        showCheckmark: that.showCheckmarks,
        onObjectiveSelected: that.onObjectiveSelected.bind(that)
      });
      that.objectiveObjects.push(objectiveObject);
    });

    this.updateCategory();
  }

  onObjectiveSelected()
  {
    this.updateCategory();
  }

  getSelectedObjectives()
  {
    let selectedObjectives = [];
    this.objectiveObjects.forEach(objective => {
      if(objective.selected)
      {
        selectedObjectives.push(objective);
      }
    });

    return selectedObjectives;
  }

  setUpEventListeners()
  {

    const TOGGLE_OPEN_BTN_ID = ".open-category-btn";
    const CHECKBOX_ID = ".special-checkbox";
    const HEADER_LABEL_ID = ".category-header-label";

    let that = this;
    this.$element.find(TOGGLE_OPEN_BTN_ID).on("click", function(e)
    {
      that.categoryOpenToggle();
    });

    this.$element.find(HEADER_LABEL_ID).on("click", function(e)
    {
      that.categoryOpenToggle();
    });

    this.$element.find(CHECKBOX_ID).on("click", function(e)
    {
      if(that.getSelectedObjectives().length === that.objectives.length)
      {
        that.unselectAllObjectives();
      }
      else
      {
        that.selectAllObjectives();
      }
      that.updateCategory();
    });

  }

  unselectAllObjectives()
  {
    this.objectiveObjects.forEach(objective => {
      objective.setUnselected();
    });
  }

  selectAllObjectives()
  {
    this.objectiveObjects.forEach(objective => {
      objective.setSelected();
    });
  }

  categoryOpenToggle()
  {
    if(this.categoryOpen)
    {
      this.$element.find(".category-objectives").show();
      this.$element.find(".open-category-btn").addClass("open");
    }
    else
    {
      this.$element.find(".category-objectives").hide();
      this.$element.find(".open-category-btn").removeClass("open");
    }
    this.categoryOpen = !this.categoryOpen;
  }

  updateCheckbox()
  {

    if(this.$element)
    {
      let $checkbox = this.$element.find(".special-checkbox");
      switch(this.getSelectedObjectives().length)
      {
        case 0:
          $checkbox.removeClass("checked").removeClass("partial");
          break;

        case this.objectives.length:
          $checkbox.addClass("checked").removeClass("partial");
          break;

        default:
          $checkbox.removeClass("checked").addClass("partial");
          break;
      }
    }
  }

  render()
  {
    this.hasRendered = false;
    this.$element = $(HtmlTemplate);
    this.$container.prepend(this.$element);
    LanguageManager.applyLocale(this.$element);

    this.updateCategory();
    this.hasRendered = true;
  }

  show()
  {
    if(utils.isNotNull(this.$element) && this.$element.length)
    {
      this.$element.show();
    }
  }

  hide()
  {
    if(utils.isNotNull(this.$element) && this.$element.length)
    {
      this.$element.hide();
    }
  }

  destroy()
  {
    if(utils.isNotNull(this.$element) && this.$element.length)
    {
      this.$element.remove();
    }
  }

  updateCategory() {
    if (utils.isNotNull(this.$element) && this.$element.length) {
      let $categoryName = this.$element.find("[data-bind-target='category-name']");
      $categoryName.empty();

      if (utils.isNotNull(this.category) && utils.isNotNull(this.category.name)) {
        $categoryName.text(this.category.name);
      }

      let $categoryLabel = this.$element.find("[data-bind-target='category-label']");
      if (utils.isNotNull(this.category) && utils.isNotNull(this.category.key)) {
        $categoryLabel.attr("for", this.category.key);
      }

      let $objectiveCount = this.$element.find("[data-bind-target='category-objective-count']");
      $objectiveCount.empty();
      $objectiveCount.text(" (" + this.getSelectedObjectives().length + "/" + this.objectives.length +")" )

      let $categoryCheckbox = this.$element.find("[data-bind-target='category-checkbox']");
      if (utils.isNotNull(this.category) && utils.isNotNull(this.category.key)) {
        $categoryCheckbox.attr("id", this.category.key);
      }

      let $objectiveWrapper = this.$element.find("[data-bind-target='category-objectives']");
      if (utils.isNotNull(this.category) && utils.isNotNull(this.category.key)) {
        $objectiveWrapper.attr("id", "objectives-" + this.category.key);
      }
    }
    this.updateCheckbox();
  }

  updateObjectives(){
    let $objectives = this.$element.find("[data-bind-target='category-objectives']");
    $objectives.empty();

    this.category.objectives.forEach((objective) => {
      let $element = $(ObjectiveTemplate);
      let $objectiveName = $element.find("[data-bind-target='objective-name']");
      $objectiveName.text(objective.name);

      $objectives.append($element);
      LanguageManager.applyLocale($element);
    });
  }


  showObjective(objective) {

    this.category.objectives.push(objective);
    this.updateObjectives();

  }

}

export default MissionObjectiveCategory;



// WEBPACK FOOTER //
// ./app/js/components/mission-objective-category.js